/** @format */

import React, { useEffect, useState } from "react";
import { NavLink, Route, Routes, useLocation } from "react-router-dom";

import Table1 from "./jadval1/Table";
import Add from "./jadval1/Add";
import pdf from "../../../../../icons/pdf.png";
import print from "../../../../../icons/print.png";
import excel from "../../../../../icons/excel.png";
import ContentTop from "../../../components/ContentTop";

const VegetatsiyaSahifa = () => {
  const location = useLocation();
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [ldate, setLdate] = useState(date);
  const [uploadDate, setUploadDate] = useState();

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  return (
    <div>
      <ContentTop>
        <ul className='content-top-left in-menu'>
          <li>Vegetatsiya</li>

          <li
            className={
              location.pathname === "/vegitatsiya/add" ? "active" : ""
            }>
            <NavLink to='/vegitatsiya/add'>Ma'lumot qo'shish</NavLink>
          </li>
        </ul>

        {location.pathname !== "/vegitatsiya/add" ? (
          <ul className='table-top-right d-flex align-items-center'>
            <li>
              <button className='btn p-0'>
                <img src={print} alt='404' />
              </button>
            </li>

            <li>
              <button className='btn p-0'>
                <img src={pdf} alt='404' />
              </button>
            </li>

            <li>
              <button className='btn p-0'>
                <img src={excel} alt='404' />
              </button>
            </li>

            <input
              type='date'
              className='form-control form-control-sm'
              value={ldate}
              onChange={(e) => setLdate(e.target.value)}
            />
          </ul>
        ) : (
          <ul className='table-top-right d-flex align-items-center'>
            <input
              type='date'
              className='form-control form-control-sm'
              value={uploadDate}
              onChange={(e) => setUploadDate(e.target.value)}
            />
          </ul>
        )}
      </ContentTop>

      <div className='tabs-content table-box'>
        <div className='tabs-content-item active controlling-table'>
          <Routes>
            <Route path='/*' element={<Table1 date={date} />} />
            <Route path='/add' element={<Add date={uploadDate} />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default VegetatsiyaSahifa;
